import React from 'react';
import styled from 'styled-components';
import FullScreenModal from '../../../../shared/components/modals/ModalWithChildren';

interface InfoInitAppProps {
    isOpen: boolean;
    onClose: () => void;
}


const InfoInitModal: React.FC<InfoInitAppProps> = ({ isOpen, onClose }) => {
    return (
        <FullScreenModal isOpen={isOpen} onClose={() => { }}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Title>⚠️ Внимание!</Title>
                <Text>
                    Страница находится в режиме тестирования. Информация о расписаниях и маршрутах может быть неполной. <br /><br />
                    Мы продолжаем работу над улучшением сервиса. Благодарим за понимание!
                </Text>
                <ContinueButton onClick={onClose}>Продолжить</ContinueButton>
            </div>
        </FullScreenModal>
    );
};

export default InfoInitModal;


const Title = styled.h2`
  font-size: 24px;
  margin-bottom: 16px;
`;

const Text = styled.p`
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const ContinueButton = styled.button`
  margin-top: auto;
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 12px;
  align-self: center;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;